module.exports = __webpack_public_path__ + "static/media/small-breakpoint-typography.b5e2a27d.jpg";